import React, { FC } from 'react';
import Card from 'react-bootstrap/Card';
import { phoneMask } from 'utils';

import { ListItem, ListSpacer, ListText, ListKey } from './style';

interface FinancialBodyType {
  nomeIe: string;
  banco: string;
  agencia: string;
  conta: string;
  nomeResponsavel: string;
  telefone: string;
  email: string;
  campusVinculados: [];
}

interface FinancialBodyProps {
  body: FinancialBodyType;
}

const FinancialBody: FC<FinancialBodyProps> = ({ body }) => {
  return (
    <Card.Body>
      <ListItem>
        <ListKey>Razão Social:</ListKey>
        <ListText>{body.nomeIe}</ListText>
      </ListItem>
      <ListItem>
        <ListKey>Banco:</ListKey>
        <ListText>{body.banco}</ListText>
      </ListItem>
      <ListItem>
        <ListKey>Agência:</ListKey>
        <ListText>{body.agencia}</ListText>
      </ListItem>
      <ListItem>
        <ListKey>Conta Corrente:</ListKey>
        <ListText>{body.conta}</ListText>
      </ListItem>
      <ListSpacer />
      <ListItem>
        <ListKey>Nome:</ListKey>
        <ListText>{body.nomeResponsavel}</ListText>
      </ListItem>
      <ListItem>
        <ListKey>Telefone:</ListKey>
        <ListText>{phoneMask(body.telefone)}</ListText>
      </ListItem>
      <ListItem>
        <ListKey>E-mail:</ListKey>
        <ListText>{body.email}</ListText>
      </ListItem>
      <ListSpacer />

      {body?.campusVinculados.length > 0 && (
        <>
          <ListItem>
            <ListKey>Instituições vinculadas ao CNPJ</ListKey>
          </ListItem>
          <ListSpacer />
        </>
      )}
      {body?.campusVinculados.map((campus) => {
        return (
          <ListItem>
            <ListText>{campus}</ListText>
          </ListItem>
        );
      })}
    </Card.Body>
  );
};

export default FinancialBody;
